import { MyActivePermissions } from '@/helpers/my-account-helper'
import _ from 'lodash'

export const permissionsMixin = {
  methods: {
    hasAllPermission: function(permission) {
      const permissions = _.isArray(permission) ? permission : [permission]
      return _.isEmpty(_.without(permissions, MyActivePermissions))
    },
    hasAnyPermission: function(permission) {
      const permissions = _.isArray(permission) ? permission : [permission]
      return !_.isEmpty(_.intersection(MyActivePermissions, permissions))
    },
    hasNoPermission: function(permission) {
      const permissions = _.isArray(permission) ? permission : [permission]
      return _.isEmpty(_.intersection(MyActivePermissions, permissions))
    }
  }
}
